import { render } from "./ButtonsPage.vue?vue&type=template&id=0a3ad07a&scoped=true"
import script from "./ButtonsPage.vue?vue&type=script&lang=js"
export * from "./ButtonsPage.vue?vue&type=script&lang=js"

import "./ButtonsPage.vue?vue&type=style&index=0&id=0a3ad07a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a3ad07a"]])

export default __exports__